import { render } from "./KlarnaV2.vue?vue&type=template&id=5e9233a4&scoped=true"
import script from "./KlarnaV2.vue?vue&type=script&lang=js"
export * from "./KlarnaV2.vue?vue&type=script&lang=js"

import "./KlarnaV2.vue?vue&type=style&index=0&id=5e9233a4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9233a4"]])

export default __exports__